import { Injectable } from '@angular/core';
import {ConfigurationDataService} from '../configuration-data.service';
import {SharedDataService} from '../shared-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {Receipt} from './receipt';

@Injectable()
export class ReceiptService {

  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  constructor(public http: HttpClient, private config : ConfigurationDataService, private shared: SharedDataService) {
  }

/**
   * List all receipts which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.receiptURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(receipt : Receipt) {
    console.log('Push receipt to insert method of service.');
    receipt.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(receipt));
    return this.http.post(this.config.receiptURL+"new", JSON.stringify(receipt), {headers: this.headers});
  }

  public update(receipt : Receipt) {
    console.log('Push receipt to insert method of service.');
    receipt.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(receipt));
    return this.http.put(this.config.receiptURL+"id/"+receipt.id, JSON.stringify(receipt), {headers: this.headers});
  }

  public qryReceipt(id : number) {
    return this.http.post(this.config.receiptURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete receipt '+ id);
    return this.http.post(this.config.receiptURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public release(id : number) {
    console.log('Release receipt '+ id);
    return this.http.post(this.config.receiptURL+"release/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }
  
  public finish(id : number) {
    console.log('Finish receipt '+ id);
    return this.http.post(this.config.receiptURL+"finish/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/receipt/receipt.service.ts